import {
  requestCommitmentItems,
  requestCommitmentStatuses,
} from 'legacy/lut/features/partner360/commitment'
import { listenerMiddleware } from 'legacy/lut/store/middlewares/listenerMiddleware'

import { getUrlParam } from 'core-components/helpers/url'
import { PID_URL } from 'partner360/configs'

import { setCockpitCommitmentDataForProgramType, setCockpitCommitmentStatuses } from '../model'

const hasPid = () => Boolean(getUrlParam(PID_URL))

listenerMiddleware.startListening({
  predicate: (action): action is ReturnType<typeof requestCommitmentItems.fulfilled> =>
    requestCommitmentItems.fulfilled.match(action) && hasPid(),
  effect: (action, { dispatch }) => {
    dispatch(
      setCockpitCommitmentDataForProgramType({
        partnerId: action.meta.arg.partnerId,
        programType: action.meta.arg.programType,
        items: action.payload,
      })
    )
  },
})

listenerMiddleware.startListening({
  predicate: (action): action is ReturnType<typeof requestCommitmentStatuses.fulfilled> =>
    requestCommitmentStatuses.fulfilled.match(action) && hasPid(),
  effect: (action, { dispatch }) => {
    dispatch(setCockpitCommitmentStatuses(action.payload))
  },
})
